import { debounce } from 'lodash';
import { useState, useEffect } from 'react';

export function useDebounceText(value: string, delay = 750): string {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const debouncedSetValue = debounce(newValue => {
    setDebouncedValue(newValue);
  }, delay);

  useEffect(() => {
    debouncedSetValue(value);

    return () => {
      debouncedSetValue.cancel();
    };
  }, [value, debouncedSetValue]);

  return debouncedValue;
}
